import React from 'react';
import PropTypes from 'prop-types';
import { useMantineTheme } from '@mantine/core';

/**
 * NumberFormatter is a formatter which simply passes a number trough, but
 * returns a dash for empty or null values.
 */
export const NumberFormatter = ({ value, style }) => {
  const { colorScheme, colors } = useMantineTheme();
  const styles = {
    span: {
      backgroundColor: colorScheme === 'dark' ? colors.dark[6] : 'white',
      color: colorScheme === 'dark' ? '#fff' : '#000',
      height: '100%',
      ...style,
    },
  };

  return (
    <span className="form-control" style={styles.span}>
      {value === '' || value === null || value === undefined ? '-' : value}
    </span>
  );
};

NumberFormatter.propTypes = {
  value: PropTypes.number,
};
